export default {
  heading: "登入資訊",
  accountSelect:{
    heading:"請選擇您想要變更的登入資訊",
    cityId:"校本帳戶",
    email:"會員帳戶",
  },  
  thirdPartyAccount:{
    heading: "將第三方帳戶與教城帳戶連繫",
    description: "您可以使用以下第三方帳戶登入教城網站。",
    connectInstruction: "請點擊以下圖示以連繫 / 取消連繫。",
    connectReminder: "彩色圖示表示已關聯到您的 EdCity 帳戶。黑色圖示表示未關聯到您的 EdCity 帳戶。",
    oauthCallback:{
      success: "第三方帳戶已成功連繫",
      identifierUsed: "第三方帳戶連繫失敗，你登入的第三方帳戶已經連繫到另一個教城帳戶。",
      userIdUsed: "第三方帳戶連繫失敗，你登入的教城帳戶已經連繫到另一個第三方帳戶。",
      unknown: "第三方帳戶連繫失敗，請稍後再試。",
      closeBtn: "關閉",
      autoCloseMessagePre: "此視窗將在 ",
      autoCloseMessagePost: " 秒後自動關閉。"
    }
  }
};
